// REACT
import React from "react";

// MATERIAL-UI
import { Grid, Link, Typography } from "@mui/material";

// ASSETS
import { PersonalDetailsStyles } from "./index.styles";
import { PersonalDetailsProps } from "./types";

const PersonalDetails = (props: PersonalDetailsProps) => {
  const classes = PersonalDetailsStyles();
  const isBroker = !props.isUser;

  return (
    <Grid container item xs={12} className={classes.container}>
      <Grid item xs={12}>
        <Typography className={classes.label}>{props.label}</Typography>
      </Grid>
      {/* Display clickable url only for Broker details*/}
      <Grid item xs={12}>
        {isBroker && props.content?.includes("@") ? (
          <Link className={classes.content} href={`mailto: ${props.content}`}>
            {props.content}
          </Link>
        ) : (
          <Typography className={classes.content}>{props.content}</Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default PersonalDetails;
